import { render, staticRenderFns } from "./CardsView.vue?vue&type=template&id=960bf892&scoped=true&"
import script from "./CardsView.vue?vue&type=script&lang=js&"
export * from "./CardsView.vue?vue&type=script&lang=js&"
import style0 from "./CardsView.vue?vue&type=style&index=0&id=960bf892&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960bf892",
  null
  
)

export default component.exports